



















































































































import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { OfficialRateModel } from "@/components/property/official-rates/types";
import { formatLocaleNumber } from "@/components/numbers/numberFormatUtils";
import PriceInput, { PriceChange } from "../../calendar/inputs/PriceInput.vue";
import NumericInputImproved from "@/components/numbers/NumericInputImproved.vue";
import { AccomodationUnitTypeViewModel } from "@/shared/models/accomodationUnitTypeViewModel";
import { OwnerPricingModelEnum } from "@/shared/models/enums.type";
import { autoCalculatePrice, calculatePrice } from "@/components/numbers/numberFormatUtils";

@Component({
  components: {
    PriceInput,
    NumericInputImproved,
  },
})
export default class OfficialRatesPrices extends Vue {
  @Getter("language/language") language?: string;
  @Getter("appParams/tenantUsesInputPrice") tenantUsesInputPrice?: boolean;

  @PropSync("officialRate") officialRateInternal?: OfficialRateModel;
  @Prop() accUnitType?: AccomodationUnitTypeViewModel;

  get isPricingModelRelative() {
    return (
      this.accUnitType?.propertyOwnerPricingModelId ==
      OwnerPricingModelEnum.Relative
    );
  }

  get rules() {
    return {
      required: (value: any) => !!value || this.$t("Validation.Required"),
      zeroOrPositive: (value: any) =>
        +value >= 0 || this.$t("Validation.MustBeZeroOrPositive"),
      undefinedOrPositive: (value: any) =>
        value === undefined ||
        value >= 0 ||
        this.$t("Validation.MustBeZeroOrPositive"),
      maxDecimals: (value: any) =>
        !(this.countDecimals(+value) > 2) ||
        this.$t("Validation.MaxDecimals{max}", {
            max: 2,
          }),
    };
  }

  get decimalSeparator() {
    const separator = Intl.NumberFormat(this.internalLanguage)
      .format(1.1)
      .replace(/\p{Number}/gu, "");
    return separator;
  }

  get internalLanguage() {
    return this.language ?? "hr-HR";
  }

  countDecimals(num: number) {
    return num.toString().split(this.decimalSeparator)[1]?.length || 0;
  }

  formatPrice(price?: number | null) {
    return price != null
      ? formatLocaleNumber(price, 2, this.internalLanguage)
      : "";
  }

  inputPriceKey = 0;
  priceKey = 0;

  //if user changes 'inputPrice' -> 'priceReference' is outputPrice to calculate from (and the other way around)
  calculatePrice(priceChange: PriceChange, userChangedInputPrice: boolean) {
      if (priceChange) {
        const priceReference = userChangedInputPrice
          ? this.officialRateInternal?.price
          : this.officialRateInternal?.inputPrice;

        const changeKey = calculatePrice(
          priceChange,
          this.officialRateInternal,
          userChangedInputPrice,
          priceReference ?? 0
        );

        if (changeKey) {
          userChangedInputPrice 
            ? this.inputPriceKey++ 
            : this.priceKey++;
        }
      }
    }

  automaticCalculation(isInputPriceChanged: boolean) {
    autoCalculatePrice(
      isInputPriceChanged,
      this.officialRateInternal,
      this.accUnitType?.propertyOwnerPayoutPercent ?? 0,
      undefined,
      undefined
    );
  }
}
